export const PX_PER_IN = 64;
export const PAGE_SIZES = { letter: [8.5, 11], a4: [8.27, 11.69], legal: [8.5, 14] };
export const IMAGE_WIDTHS = { small: 160, medium: 280, large: 440 };
export const STYLE_CSS = {
  normal: {},
  title: { fontSize: 26, fontWeight: 400, color: "#000" },
  subtitle: { fontSize: 15, fontWeight: 400, color: "#666" },
  h1: { fontSize: 20, fontWeight: 400, color: "#000" },
  h2: { fontSize: 16, fontWeight: 700, color: "#000" },
  h3: { fontSize: 14, fontWeight: 700, color: "#434343" },
};
export const HEADING_STYLES = ["title", "h1", "h2", "h3"];
export const TEXT_TYPES = ["paragraph", "bullet", "number", "check"];

export const newId = (p) => `${p}_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 5)}`;

export const withDefaults = (doc) => ({
  title: "Untitled document", header: "", footerPageNumber: false, page: { orientation: "portrait", size: "letter", margin: 1.0 },
  comments: [], shared: [], mode: "editing", folder: "My Files", showRuler: true, showOutline: false, downloaded: [],
  ...doc, page: { orientation: "portrait", size: "letter", margin: 1.0, ...(doc.page || {}) },
});

export function pageDims(page) {
  const [w, h] = PAGE_SIZES[page.size] || PAGE_SIZES.letter;
  const land = page.orientation === "landscape";
  return { width: (land ? h : w) * PX_PER_IN, height: (land ? w : h) * PX_PER_IN, margin: (page.margin || 1) * PX_PER_IN };
}

export function paginate(blocks) {
  const pages = [[]];
  blocks.forEach((b, i) => {
    if (b.pageBreakBefore && i > 0) pages.push([]);
    pages[pages.length - 1].push(b);
  });
  return pages;
}

export const headingsOf = (blocks) => {
  const pages = paginate(blocks);
  const out = [];
  pages.forEach((pg, pi) => pg.forEach((b) => { if (TEXT_TYPES.includes(b.type) && HEADING_STYLES.includes(b.style)) out.push({ ...b, page: pi + 1 }); }));
  return out;
};

export function wordStats(doc) {
  const text = (doc.blocks || []).map((b) => (b.type === "table" ? (b.cells || []).flat().join(" ") : b.text || "")).join(" ");
  const words = text.trim().split(/\s+/).filter(Boolean);
  return { pages: paginate(doc.blocks || []).length, words: words.length, chars: text.replace(/\n/g, "").length, charsNoSpace: text.replace(/\s/g, "").length };
}

export function findMisspellings(doc, map) {
  const out = [];
  for (const b of doc.blocks || []) {
    if (!TEXT_TYPES.includes(b.type)) continue;
    for (const w of (b.text || "").split(/[^A-Za-z']+/)) {
      const fix = map[w.toLowerCase()];
      if (fix && !out.some((o) => o.blockId === b.id && o.word.toLowerCase() === w.toLowerCase())) out.push({ blockId: b.id, word: w, fix });
    }
  }
  return out;
}

export function blockCss(b) {
  const st = STYLE_CSS[b.style || "normal"] || {};
  const f = b.fmt || {};
  const styled = b.style && b.style !== "normal";
  return {
    fontWeight: f.bold ? 700 : st.fontWeight || 400,
    fontStyle: f.italic ? "italic" : "normal",
    textDecoration: f.underline || f.link ? "underline" : "none",
    fontFamily: f.fontFamily || "Arial",
    fontSize: `${styled ? st.fontSize : f.fontSize || 11}px`,
    color: f.link ? "#1a73e8" : styled && (!f.color || f.color === "#0f172a") ? st.color : f.color,
    backgroundColor: f.highlight || "transparent",
    textAlign: f.align || "left",
    lineHeight: f.lineSpacing || 1,
    paddingLeft: `${(f.indent || 0) * 36}px`,
  };
}

export const SHORTCUTS = [
  ["Bold", "Ctrl+B"], ["Italic", "Ctrl+I"], ["Underline", "Ctrl+U"], ["Insert link", "Ctrl+K"], ["Find and replace", "Ctrl+H"],
  ["Page break", "Ctrl+Enter"], ["Insert comment", "Ctrl+Alt+M"], ["Word count", "Ctrl+Shift+C"], ["Define word", "Ctrl+Shift+Y"],
  ["Voice typing", "Ctrl+Shift+S"], ["Print", "Ctrl+P"], ["Undo", "Ctrl+Z"], ["Redo", "Ctrl+Y"], ["Keyboard shortcuts", "Ctrl+/"],
];
